import React from 'react';
import Nav from './Nav';
import First from './First';
import Second from './Second';
import Third from './Third';
import Footer from './Footer';
import '../style/app.css';

export default function App(){
  return(
    <div>
      <Nav />
      <First />
      <Second />
      <Third />
      <Footer />
    </div>
  )
}